import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MonitorPlay, User, Building2, ExternalLink, Star } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

const CARDS = [
  {
    to: "/apresentacao-particular",
    icon: User,
    titulo: "Demo Cliente Particular",
    desc: "O empresário vive a jornada do consumidor final: QR Code, oferta, contrato, pagamento simulado, agendamento, montagem, assistência e troca total com ressarcimento à Loja.",
    cor: "#FF6700",
    testid: "showroom-particular",
  },
  {
    to: "/apresentacao-empresa",
    icon: Building2,
    titulo: "Demo Empresa",
    desc: "A operação completa de uma loja: importação de planilha, distribuição, os 5 clientes da demonstração, assistência com SLA de 30 dias, troca total e Pulmão de Peças.",
    cor: "#126BFF",
    testid: "showroom-empresa",
  },
];

export default function Showroom() {
  const [modelos, setModelos] = useState({ modelos: [], recentes: [] });
  const carregar = () => api.get("/demo/modelos").then(r => setModelos(r.data)).catch(() => {});
  useEffect(() => { carregar(); }, []);
  const toggle = async (id) => {
    try { const r = await api.post(`/demo/servicos/${id}/template`); toast.success(r.data.is_demo_template ? "Salvo como Modelo permanente" : "Modelo removido"); carregar(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };
  return (
    <div className="space-y-6" data-testid="showroom-hub">
      <div>
        <div className="flex items-center gap-2 text-aj-blue-deep">
          <MonitorPlay size={22} />
          <h1 className="text-2xl font-extrabold">Showroom de Vendas</h1>
        </div>
        <p className="text-sm text-aj-text-muted mt-1 max-w-2xl">
          Modo Apresentação para TV: um gêmeo controlado da produção, com dados 100% fictícios e isolados
          (<code>is_demo</code>). Escolha a demonstração, conecte a TV e escaneie o QR Code com o celular do convidado.
        </p>
      </div>
      <div className="grid md:grid-cols-2 gap-5 max-w-4xl">
        {CARDS.map((c) => (
          <Link key={c.to} to={c.to} data-testid={c.testid}
            className="group rounded-2xl border border-border bg-white p-6 hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
              style={{ background: `${c.cor}18`, color: c.cor }}>
              <c.icon size={24} />
            </div>
            <div className="flex items-center gap-2">
              <h2 className="font-extrabold text-aj-blue-deep text-lg">{c.titulo}</h2>
              <ExternalLink size={14} className="text-aj-text-muted opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
            <p className="text-sm text-aj-text-muted mt-2 leading-relaxed">{c.desc}</p>
            <div className="mt-4 text-sm font-bold" style={{ color: c.cor }}>Abrir apresentação →</div>
          </Link>
        ))}
      </div>
      <div className="rounded-xl border border-border bg-white p-4 max-w-4xl" data-testid="showroom-modelos">
        <div className="flex items-center gap-2 font-bold text-aj-blue-deep text-sm mb-1">
          <Star size={15} className="text-[#FF6700]" /> Modelos de demonstração (permanentes)
        </div>
        <p className="text-xs text-aj-text-muted mb-3">
          OS marcadas como Modelo (<code>is_demo_template</code>) sobrevivem ao Encerrar/Reset e são clonadas
          automaticamente em cada nova sessão — sua base fixa para as próximas reuniões.
        </p>
        {modelos.modelos.length === 0 && <div className="text-xs text-aj-text-muted italic mb-2">Nenhum modelo salvo ainda.</div>}
        {modelos.modelos.map(m => (
          <div key={m.id} className="flex items-center justify-between text-xs border-b border-border/60 py-1.5" data-testid={`modelo-${m.id}`}>
            <span><b>{m.pim_code}</b> · {m.cliente_nome} · {m.tipo} · {m.status}</span>
            <button onClick={() => toggle(m.id)} className="px-2 py-1 rounded border border-red-200 text-red-500 font-bold hover:bg-red-50" data-testid={`modelo-remover-${m.id}`}>Remover modelo</button>
          </div>
        ))}
        {modelos.recentes.length > 0 && (
          <details className="mt-3">
            <summary className="text-xs font-bold text-aj-blue-deep cursor-pointer">OS demo recentes — salvar como Modelo ({modelos.recentes.length})</summary>
            {modelos.recentes.map(m => (
              <div key={m.id} className="flex items-center justify-between text-xs border-b border-border/60 py-1.5">
                <span><b>{m.pim_code}</b> · {m.cliente_nome} · {m.tipo} · {m.status}</span>
                <button onClick={() => toggle(m.id)} className="px-2 py-1 rounded border border-border font-bold hover:bg-secondary" data-testid={`modelo-salvar-${m.id}`}>★ Salvar como Modelo</button>
              </div>
            ))}
          </details>
        )}
      </div>
      <div className="rounded-xl border border-border bg-[#F8FAFC] p-4 max-w-4xl text-xs text-aj-text-muted space-y-1">
        <div className="font-bold text-aj-blue-deep text-sm mb-1">Rede demo permanente</div>
        <div>• <b>Bela Móveis (Demo)</b> — belamoveis@belamoveos.com · <b>Ébano e Marfim (Demo)</b> — montadora gestora · <b>Montador Demo</b> — montdemo@belamoveis.com.br.</div>
        <div>• A TV mostra o QR Code, o feed "O que está acontecendo?", o financeiro em tempo real e a barra MODO APRESENTAÇÃO.</div>
        <div>• WhatsApp real é enviado somente ao número informado pelo participante, identificado como 🧪 DEMONSTRAÇÃO.</div>
        <div>• Encerrar/Reset apaga apenas a atividade da sessão (is_demo) — a rede e os Modelos (is_demo_template) permanecem.</div>
      </div>
    </div>
  );
}
